/**
 * @generated SignedSource<<13c642a6a18b49adb0e186ecc2772b36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksUsePageTargetingArticle$data = {
  readonly firstTopic: {
    readonly name: string;
  } | null | undefined;
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "hooksUsePageTargetingArticle";
};
export type hooksUsePageTargetingArticle$key = {
  readonly " $data"?: hooksUsePageTargetingArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUsePageTargetingArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksUsePageTargetingArticle"
};

(node as any).hash = "8fab2a0f572c52f6a64863886ec44e27";

export default node;
